import ErrorBoundary from './components/ui/ErrorBoundary';
import AppShell from './components/nav/nav';
import './global.css';

/**
 * Main Application Component
 */
const App = () => (
  <ErrorBoundary>
    <AppShell />
  </ErrorBoundary>
);

export default App;
